import classNames from "classnames";
import type { FC, PropsWithChildren } from "react";
import styles from "./styles.module.scss";

type Props = {
  direction?: "row" | "column";
  className?: string;
};

export const FieldLayout: FC<PropsWithChildren<Props>> = ({
  direction = "column",
  className,
  children,
}) => {
  return <div className={classNames(styles.root, styles[direction], className)}>{children}</div>;
};
